import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Put = async (path, data) => {
  const result = await axiosInstance.put(`${baseUrl}/${path}`, data);
  return result;
};

export default Put;
